var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c("p", { staticClass: "title is-3" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("p", { staticClass: "subtitle is-5" }, [
          _vm._v(_vm._s(_vm.subtitle)),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "block" }, [
          _c(
            "p",
            { staticClass: "mb-2" },
            [
              _c(
                "b-tooltip",
                { attrs: { label: "Nombre", position: "is-right" } },
                [
                  _c("i", { staticClass: "fas fa-user fa-fw" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.user.apellido) +
                      ", " +
                      _vm._s(_vm.user.nombre) +
                      "\n        "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "mb-2" },
            [
              _c(
                "b-tooltip",
                { attrs: { label: "CUIL", position: "is-right" } },
                [
                  _c("i", { staticClass: "fas fa-id-badge fa-fw" }),
                  _vm._v(" " + _vm._s(_vm.user.cuil) + "\n        "),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            [
              _c(
                "b-tooltip",
                { attrs: { label: "Email", position: "is-right" } },
                [
                  _c("i", { staticClass: "fas fa-envelope fa-fw" }),
                  _vm._v(" " + _vm._s(_vm.user.email) + "\n        "),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.showReason
          ? _c("div", { staticClass: "block" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Motivo")]),
                _vm._v(" "),
                _c("div", { staticClass: "control" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.reason,
                        expression: "reason",
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: `max:${_vm.getMaxLength}`,
                        expression: "`max:${getMaxLength}`",
                      },
                    ],
                    ref: "motivo",
                    staticClass: "input",
                    class: { "is-danger": _vm.errors.has("motivo") },
                    attrs: { type: "text", name: "motivo" },
                    domProps: { value: _vm.reason },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.reason = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _vm.errors.has("motivo")
                  ? _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.errors.first("motivo"))),
                    ])
                  : _c("p", { staticClass: "help" }, [
                      _vm._v("Breve descripción del motivo de baja (opcional)"),
                    ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("b-notification", {
          attrs: { type: "is-info is-light", closable: false },
          domProps: { innerHTML: _vm._s(_vm.footerText) },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.isLoading
      ? _c("div", { staticClass: "card-footer" }, [
          _c(
            "span",
            {
              staticClass: "card-footer-item animated flash slow",
              attrs: { type: "button" },
            },
            [
              _c("i", { staticClass: "fas fa-sync fa-spin" }),
              _vm._v(" " + _vm._s(_vm.loadingText) + "\n    "),
            ]
          ),
        ])
      : _c("div", { staticClass: "card-footer" }, [
          _c(
            "a",
            {
              staticClass: "card-footer-item",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$parent.close()
                },
              },
            },
            [_vm._v("Cancelar")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "card-footer-item has-text-weight-bold is-uppercase",
              class: { "has-text-danger": _vm.buttonDangerColor },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.confirm.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm.action))]
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }